import React, { useState } from 'react';

export default function DigitalShowroomCard({ visualizerToken }) {
  const [copied, setCopied] = useState(false);

  // Construct full showroom URL
  const showroomUrl = `${window.location.origin}/digital-showroom/${visualizerToken}`;

  const handleOpenShowroom = () => {
    window.open(`/digital-showroom/${visualizerToken}`, '_blank');
  };

  const handleCopyUrl = async () => {
    try {
      await navigator.clipboard.writeText(showroomUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy URL:', err);
    }
  };

  return (
    <div className="bg-white rounded-2xl border border-gray-100 p-8 shadow-sm flex flex-col items-center justify-center text-center overflow-hidden relative font-sans w-full min-h-[300px]">
  
  {/* Content Column */}
  <div className="max-w-xl z-10 space-y-4 flex flex-col items-center">
    <h2 className="text-2xl font-bold text-gray-800 tracking-tight">
      Introducing Digital Showroom
    </h2>
    <p className="text-sm text-gray-500 leading-relaxed">
      Bring your entire product collection to life. Create stunning catalogs, organize products effortlessly, and visualize your products and drive engagement.
    </p>

    {/* Action Buttons */}
    <div className="flex items-center justify-center gap-3 pt-2">
      <button
        type="button"
        onClick={handleOpenShowroom}
        className="px-5 py-2.5 bg-[#4F566B] hover:bg-[#3E4455] text-white text-xs font-semibold rounded-lg shadow-sm transition-colors"
      >
        Open digital showroom
      </button>
      <button
        type="button"
        onClick={handleCopyUrl}
        className="px-5 py-2.5 bg-white border border-gray-300 hover:bg-gray-50 text-xs font-semibold text-gray-700 rounded-lg transition-colors"
      >
        {copied ? 'Copied!' : 'Copy URL'}
      </button>
    </div>
  </div>

</div>
  );
}